// Only send editable fields. Never send the masked credential back as an API Key.
export function createModelConfigPayload(values, existing) {
  const payload = {
    name: values.name.trim(),
    providerCode: values.providerCode,
    modelId: values.modelId,
    enabled: values.enabled,
  };
  if (values.apiKey) payload.apiKey = values.apiKey;
  if (existing) payload.configVersion = existing.configVersion;
  return payload;
}

export function requiresModelApiKey(existing, providerCode) {
  return !existing || existing.providerCode !== providerCode;
}

export function isValidModelApiKey(key) {
  return key.length <= 8192 && !/[\s*]/.test(key) && !Array.from(key).some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || (code >= 127 && code <= 159);
  });
}
